import { useEffect, useState } from "react";
import { Download, PlusSquare, Share } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

let deferred = null; // evento beforeinstallprompt (Android/Chrome/Edge), compartido entre botones
const subs = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; subs.forEach((f) => f()); });
  window.addEventListener("appinstalled", () => { deferred = null; subs.forEach((f) => f()); });
}
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const Step = ({ n, children }) => <li className="flex gap-3"><span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-[var(--forest)] text-sm font-bold text-white">{n}</span><span className="pt-0.5">{children}</span></li>;

/** Botón "Instalar app": usa el instalador del navegador o muestra los pasos (iPhone y otros). */
export const InstallApp = ({ testid = "install-app", className = "", children }) => {
  const [, force] = useState(0);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(false);
  useEffect(() => { const f = () => force((x) => x + 1); subs.add(f); setInstalled(standalone()); return () => { subs.delete(f); }; }, []);
  if (installed) return typeof children === "function" ? children(true) : null;
  const click = async () => {
    if (!deferred) return setHelp(true);
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") { deferred = null; setInstalled(true); }
  };
  const ios = isIOS();
  return (
    <>
      {children ? (
        <button type="button" onClick={click} data-testid={testid} aria-label="Instalar la app de Santiagueño en tu celular" className={className}>{typeof children === "function" ? children(false) : children}</button>
      ) : (
      <button type="button" onClick={click} data-testid={testid}
        className={`inline-flex items-center gap-2 rounded-full bg-[var(--lime)] px-5 py-2.5 text-sm font-bold text-[var(--ink)] transition-transform duration-200 hover:scale-105 ${className}`}>
        <Download className="h-4 w-4" /> Instalar app en tu celular
      </button>
      )}
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid={`${testid}-help`} className="max-w-md rounded-3xl">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Santiagueño en tu pantalla de inicio</DialogTitle>
            <DialogDescription>Queda el ícono en tu celular y se abre como una app, con tu pasaje y QR a mano.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm">
            {ios ? (
              <>
                <Step n={1}>Abrí esta página en <b>Safari</b>.</Step>
                <Step n={2}>Tocá <b>Compartir</b> <Share className="inline h-4 w-4" /> abajo en la pantalla.</Step>
                <Step n={3}>Elegí <b>Agregar a inicio</b> <PlusSquare className="inline h-4 w-4" /> y tocá <b>Agregar</b>.</Step>
              </>
            ) : (
              <>
                <Step n={1}>Abrí esta página en <b>Chrome</b> desde tu celular.</Step>
                <Step n={2}>Tocá el menú <b>⋮</b> arriba a la derecha.</Step>
                <Step n={3}>Elegí <b>Instalar app</b> o <b>Agregar a la pantalla principal</b>.</Step>
              </>
            )}
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
